export default "__VITE_ASSET__DPo1lt0f__"